import speedIcon from '../../constants/icons/clock_speed_icon.png';
import locationIcon from '../../constants/icons/marker_pin_icon.png';
import lengthIcon from '../../constants/icons/arrow_lr_icon.png';
import scoreIcon from '../../constants/icons/flag_icon.png';
import blockIcon from '../../constants/icons/globe_icon.png';

interface IProps {
  velocity: number;
  fieldLength: number;
  winningScore: number;
  currentBlock: number;
  kickedBlock: number;
}

const TnCGameBallStats: React.FC<IProps> = ({
  velocity,
  fieldLength,
  winningScore,
  currentBlock,
  kickedBlock
}: IProps) => {
  const roundedVelocity = Math.round(velocity / 100) / 10;
  const roundedFieldLength = Math.round(fieldLength / 100) / 10;

  let ballLocation =
    Math.round((velocity * (currentBlock - kickedBlock)) / 100) / 10;
  if (ballLocation > roundedFieldLength) {
    ballLocation = roundedFieldLength;
  }

  return (
    <div className="tncGameBallStatsContainer">
      <ul className="tncGameBallStatsDivider">
        <li className="tncGameBallStatsListItem">
          <img
            src={speedIcon}
            alt="speedIcon"
            className="tncGameBallStatsIcon"
          />
          Ball Speed:
        </li>
        <li className="tncGameBallStatsListItem">
          <img
            src={locationIcon}
            alt="locationIcon"
            className="tncGameBallStatsIcon"
          />
          Ball Location:
        </li>
        <li className="tncGameBallStatsListItem">
          <img
            src={lengthIcon}
            alt="lengthIcon"
            className="tncGameBallStatsIcon"
          />
          Field Length:
        </li>
        <li className="tncGameBallStatsListItem">
          <img
            src={scoreIcon}
            alt="scoreIcon"
            className="tncGameBallStatsIcon"
          />
          Win Score:
        </li>
        <li className="tncGameBallStatsListItem">
          <img
            src={blockIcon}
            alt="blockIcon"
            className="tncGameBallStatsIcon"
          />
          Current Block:
        </li>
      </ul>
      <ul className="tncGameBallStatsDivider">
        <li>{roundedVelocity} m/block</li>
        <li>{ballLocation} m</li>
        <li>{roundedFieldLength} m</li>
        <li>{winningScore}</li>
        <li>#{currentBlock}</li>
      </ul>
    </div>
  );
};

export default TnCGameBallStats;
